import { useMediaQuery } from '@material-ui/core';

import { channelAgentNameFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/channelAgentNameFieldColumn';
import { createdAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/createdAtFieldColumn';
import { statusFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/statusFieldColumn';
import { updatedAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/updatedAtFieldColumn';
import { borrowerContactDetailsFieldColumn } from '@/components/modules/CreditCard/List/CreditCardDataGridFields/components/borrowerContactDetailsFieldColumn';
import { borrowerNameFieldColumn } from '@/components/modules/CreditCard/List/CreditCardDataGridFields/components/borrowerNameFieldColumn';
import { cardTypeFieldColumn } from '@/components/modules/CreditCard/List/CreditCardDataGridFields/components/cardTypeFieldColumn';
import { toCreditCardDetailFieldColumn } from '@/components/modules/CreditCard/List/CreditCardDataGridFields/components/toCreditCardDetailFieldColumn';
import { updatedAtWithBorrowerNameFieldColumnMobile } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/updatedAtWithBorrowerNameFieldColumnMobile';
import { ApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export function CreditCardDataGridFields() {
  const { breakpoints } = useCustomTheme();

  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const creditCardFields = {
    desktop: [
      cardTypeFieldColumn({ flex: 0.05 }),
      borrowerNameFieldColumn({ flex: 0.13 }),
      borrowerContactDetailsFieldColumn({ flex: 0.13 }),
      channelAgentNameFieldColumn({ flex: 0.11 }),
      createdAtFieldColumn({ flex: 0.14 }),
      updatedAtFieldColumn({ flex: 0.14 }),
      statusFieldColumn({ applicationType: ApplicationType.CARD, flex: 0.15, sortable: false }),
      toCreditCardDetailFieldColumn({ flex: 0.06 }),
    ],
    mobile: [
      updatedAtWithBorrowerNameFieldColumnMobile({ flex: 0.55 }),
      statusFieldColumn({ applicationType: ApplicationType.CARD, flex: 0.45 }),
    ],
  };

  return isDownMd ? creditCardFields.mobile : creditCardFields.desktop;
}
